import api from './api';

export const leaderboardService = {
  // Get all-time leaderboard
  getAllTime: async () => {
    const response = await api.get('/leaderboard/all-time');
    return response.data;
  },

  // Get weekly leaderboard
  getWeekly: async () => {
    const response = await api.get('/leaderboard/weekly');
    return response.data;
  },

  // Get monthly leaderboard
  getMonthly: async () => {
    const response = await api.get('/leaderboard/monthly');
    return response.data;
  },

  // Get current user's rank
  getMyRank: async () => {
    const response = await api.get('/leaderboard/my-rank');
    return response.data;
  },
};
